import React, { useState } from 'react'
import styled from 'styled-components'

import TimelineItem from '../common/Timeline'
import Map from '../common/Map'

/**
* @author zilahir
* @function Event
**/

const TimelineContainer = styled.div`
	padding: 80px;
	flex: 1;
`

const InnerContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
`

const DetailsContainer = styled.div`
	padding: 80px;
	flex: 1;
`

const event ={
	tite: 'Makkarapaiva',
	description: 'lorem ipsum',
	duration: 8,
	location: 'Helsinki',
	timezone: 'FI',
}

const AddToCal = () => (
	<p>
		Add to calendar
	</p>
)

const Event = () => {
	const [visibleIndex, setVisibleIndex] = useState(null)
	return(
		<section id="four" className="wrapper style2 fade-up">
			<div className="add-to-calendar">

			</div>
			<InnerContainer>
				<TimelineContainer>
					{
						Array(6).fill().map((t, i) => (
							<TimelineItem
						strokeColor="#ffffff"
						color="#ffffff"
						onClick={() => setVisibleIndex(i)}
					/>
						))
					}
				</TimelineContainer>
				<DetailsContainer>
					{
						visibleIndex
							? (
								Array(6).fill().map((d, i) => (
									<div
										style={
											i === visibleIndex ? {display: 'block'} : {display: 'none'}
										}
									>
										<h2>
											some details will come here {i}
										</h2>
									</div>
								))
							)
							: <Map />
					}
				</DetailsContainer>
			</InnerContainer>
		</section>
	 )

 }

export default Event